import { useQuery } from "@tanstack/react-query";
import { useGraphql } from "~/api-client";

export interface PriorityMessage {
  messageId: string;
  source: string;
  header: string;
  body: string;
  /** eg ["cart-always"]. Use `hasFlag` to read it. */
  flags: string[];
  isGlobal: boolean;
  updatedAt: string;
}

export function hasFlag(message: PriorityMessage, flag: string): boolean {
  return message.flags.includes(flag);
}

export function usePriorityMessages(locationRef: string | null): {
  priorityMessages: PriorityMessage[];
  loading: boolean;
  refetch: () => void;
} {
  // we dont need the featureFlag check for jets
  const { getPriorityMessages } = useGraphql();
  const {
    data: priorityMessages = [],
    isFetching: loading,
    refetch,
  } = useQuery({
    queryKey: ["priority-messages", locationRef],
    queryFn: async () =>
      (await getPriorityMessages(locationRef)).priorityMessages,
    enabled: Boolean(locationRef),
    refetchOnWindowFocus: false,
    refetchInterval: 60_000,
    staleTime: 60_000,
  });

  return {
    priorityMessages,
    loading,
    refetch,
  };
}
